const translations = {
    activationLinkSent:
        'An account activation link has been sent to the email address you provided. This link will expire in 1 hour.',
    apiError: 'Something went wrong. Please try again.',
    backToLogin: 'Back to Login',
    didNotGetLink: 'Didn’t get the link?',
    emailResent: 'Successfully resent the verification email, please check your inbox',
    sendAgain: 'Send again',
    title: 'Verify your Email'
};

export default translations;
